enum PriorityNumber {
  MEDIUM = 100,
  HIGH = 1000
}

export default PriorityNumber;
